import service from "@/router/request";
/**
 * 查询活动表单模板列表
 * @param params 查询条件
 */
export async function listEventMetadatas(params) {
    const res = await service.get('/business/eventMetadata', {
        params
    });
    if (res.data.code === 0 && res.data.data) {
        return res.data.data;
    }
    return Promise.reject(new Error(res.data.message));
}

/**
 * 报名
 */
export async function saveregister(data) {
    const res = await service.post('/business/eventMetadataData', data);
    if (res.data.code === 0) {
        return res.data.message;
    }
    return Promise.reject(new Error(res.data.message));
}

/**
 * 查询活动报名用户信息
 * @param params 查询条件
 */
export async function listEventuserdatas(params) {
    const res = await service.get('/business/eventMetadataData/getLastData', {
        params
    });
    if (res.data.code === 0 && res.data.data) {
        return res.data.data;
    }
    return Promise.reject(new Error(res.data.message));
}
